module.exports = __webpack_public_path__ + "static/media/Frame 3481.b9979d34.png";